import React from 'react';
import PropTypes from 'prop-types';
import {
  Button, Card, CardBody, CardFooter, CardHeader, Col, Row, Table,
} from 'reactstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { deleteWebCountry, fetchWebCountry } from '../../actions/web-countries';
import PinModal from '../../components/pin';

const DetailRow = ({ label, value }) => (
  <tr>
    <td>{label}</td>
    <td><strong>{value === null || value === undefined ? '' : String(value)}</strong></td>
  </tr>
);

DetailRow.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
DetailRow.defaultProps = { value: '' };

class WebCountry extends React.Component {
  constructor(props) {
    super(props);
    this.state = { submitted: false };
    this.handleDelete = this.handleDelete.bind(this);
  }

  componentWillMount() {
    const { getWebCountry } = this.props;
    getWebCountry();
  }

  handleDelete() {
    const { deleteAction, goToList } = this.props;
    deleteAction().then((result) => {
      if (result.ok) goToList();
      else this.setState({ submitted: false });
    });
  }

  render() {
    const { country, goToEdit } = this.props;
    const { submitted } = this.state;
    if (!country || Object.keys(country).length === 0) return null;
    return (
      <div className="animated fadeIn">
        {submitted && (
          <PinModal
            successSubmit={this.handleDelete}
            failedSubmit={() => this.setState({ submitted: false })}
          />
        )}
        <Row>
          <Col lg={8}>
            <Card>
              <CardHeader>
                <strong>{`Web Country ID: ${country.id}`}</strong>
                <div className="card-header-actions">
                  <Button color="link" className="card-header-action btn-setting" onClick={goToEdit}>
                    <i className="icon-note" />
                  </Button>
                  <Button color="link" className="card-header-action btn-setting" onClick={() => this.setState({ submitted: true })}>
                    <i className="icon-trash" />
                  </Button>
                </div>
              </CardHeader>
              <CardBody>
                <Table responsive striped hover>
                  <tbody>
                    <DetailRow label="ID:" value={country.id} />
                    <DetailRow label="English Name:" value={country.name_en} />
                    <DetailRow label="French Name:" value={country.name_fr} />
                    <DetailRow label="Arabic Name:" value={country.name_ar} />
                    <DetailRow label="English Description:" value={country.description_en} />
                    <DetailRow label="French Description:" value={country.description_fr} />
                    <DetailRow label="Arabic Description:" value={country.description_ar} />
                    <DetailRow label="Original Country:" value={country.country && country.country.name} />
                    <DetailRow label="Original Country ID:" value={country.country_id} />
                    <DetailRow label="ISO Country Code:" value={country.ISOcountryCode} />
                    <DetailRow label="Timezone Offset:" value={country.timezone} />
                    <DetailRow label="Enabled:" value={country.enabled} />
                  </tbody>
                </Table>
              </CardBody>
              <CardFooter>
                <Button color="secondary" size="sm" onClick={goToEdit}>Edit</Button>
                {' '}
                <Button color="danger" size="sm" onClick={() => this.setState({ submitted: true })}>Delete</Button>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

WebCountry.propTypes = {
  country: PropTypes.shape({}),
  deleteAction: PropTypes.func.isRequired,
  getWebCountry: PropTypes.func.isRequired,
  goToEdit: PropTypes.func.isRequired,
  goToList: PropTypes.func.isRequired,
};
WebCountry.defaultProps = { country: {} };

const mapStateToProps = ({ webCountries }) => ({ country: webCountries.item });
const mapDispatchToProps = (dispatch, ownProps) => bindActionCreators({
  deleteAction: () => deleteWebCountry(ownProps.match.params.id),
  getWebCountry: () => fetchWebCountry(ownProps.match.params.id),
  goToEdit: () => push(`/web-countries/${ownProps.match.params.id}/edit`),
  goToList: () => push('/web-countries'),
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(WebCountry);
